// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"6a1e2e14","118":"ff52c454","443":"112e6880","547":"3de18471","785":"8da910e7","945":"86bbab85"}[chunkId] + ".chunk.js";
};